import {Injectable} from "@angular/core";
import {APIProxy} from "../../../../common/http/services/api.proxy";
import {Patient} from "../models/patient";
import {HttpObservable} from "../../../../common/http/services/http.wrapper";
import {IClinicalResponse} from "../../interfaces/clinical.response";
import {IClinicalRequest} from "../../interfaces/clinical.request";
import {PatientId, PatientIdValidation} from "../models/patient.id";
import {Visit} from "../../visit/models/visit";
/**
 * Created by shahar on 11-Jul-16.
 */

@Injectable({ providedIn: 'root' })
  export class PatientProxy {
	constructor(private http:APIProxy){
	}

	public generatePatientId(): HttpObservable<PatientId> {
		return this.http.get("Patient","GetGeneratePatientId");
	}

	public getPatientIdsByPatientPersonKey(patientPersonKey: number): HttpObservable<PatientId[]> {
		return this.http.get("Patient","GetPatientIdsByPatientPersonKey",{pName: "patientPersonKey", pVal: patientPersonKey});
	}

	public getPatientById(pId: string): HttpObservable<{patient:Patient}>{
		return this.http.get("Patient","GetPatientDetailByPatientId",{pName:"patientId",pVal:pId});
	}

	public getPatientByIdAndIssuer(pId: string, issuerOfPid: number): HttpObservable<{patient:Patient}>{
		return this.http.get("Patient","GetPatientDetailByPatientIdAndIssuer",
			[{pName:"patientId",pVal:pId}, {pName:"issuerOfPid",pVal:issuerOfPid}]);
	}

	public getPatient(pKey: number): HttpObservable<{patient:Patient}>{
		return this.http.get("Patient","GetPatientDetailByPatientKey",{pName:"patientKey",pVal:pKey});
	}

	// public getPortalPatient(): HttpObservable<{patient:Patient}>{
	// 	return this.http.get("Patient","GetPatientDetailByPatientKey");
	// }

	public getEmptyPatientDetails(): HttpObservable<{patient:Patient}>{
		return this.http.get("Patient","GetEmptyPatientDetails");
	}

	/**
	 * Gets patient picture by patientPersonKey.
	 * @param patientPersonKey The patient person key.
	 * @returns A promise containing patient picture in base64 format.
	 */
	public getPatientPictureByPatientPersonKey(patientPersonKey: number): HttpObservable<Blob> {
		return this.http.getBlob("Patient","GetPatientPictureByPatientPersonKey",{pName:"patientPersonKey",pVal:patientPersonKey}, null, false, true);
	}

	public isPatientIdValidAndNotInUse(pId: string, pIdIssuer: number): HttpObservable<PatientIdValidation> {
		return this.http.get("Patient","GetIsPatientIdValidAndNotInUse", [{pName: "pId", pVal: pId}, {pName: "pIdIssuer", pVal: pIdIssuer}]);
	}

	public updatePatient(req: IClinicalRequest): HttpObservable<IClinicalResponse> {
		return this.http.put("Patient", "PutUpdatePatient", req);
	}

	public updatePatientId(currentPatientId: string, currentIssuer: number, newPatientId: string, newIssuer: number): HttpObservable<number> {
		return this.http.put("Patient",  "PutUpdatePatientPrimaryId", null, [
			{pName: "currentPatientId", pVal: currentPatientId},
			{pName: "currentIssOfPid", pVal: currentIssuer},
			{pName: "newPatientId", pVal: newPatientId},
			{pName: "newIssOfPid", pVal: newIssuer}
		]);
	}

	public getPatientVisitList(patientPersonKey: number): HttpObservable<Visit[]> {
		return this.http.get("Patient","GetPatientVisitList",{pName:"patientPersonKey",pVal:patientPersonKey}, null, false);
	}
}
